import { BasicButton } from "@/components";
import { BackAppBar } from "@/components/ui";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import PhoneIcon from "@mui/icons-material/Phone";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/dashboard/accounts/settings/account/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation("nav");
	return (
		<div className="wrapper !p-0 h-full mx-auto">
			<BackAppBar
				to="/dashboard/accounts"
				className="!bg-gradient-account [&_*_]:text-white"
				titleKey="accountSettings"
			/>
			<div className="h-full container bg-gray-light -translate-y-16 pt-16">
				<Stack
					className="h-full w-full py-3"
					justifyContent="space-between"
					alignItems="center"
				>
					<Stack spacing={2} className="w-full">
						<Link
							to="/dashboard/accounts/settings/account/change-email"
							className="w-full bg-white rounded-xl text-dark px-3"
						>
							<Box className="flex justify-start items-center gap-1 py-3 cursor-pointer">
								<EmailIcon />
								<p className="text-sm font-medium flex flex-1">
									{t("changeEmail")}
								</p>
								<ChevronRightIcon />
							</Box>
						</Link>
						<Link
							to="/dashboard/accounts/settings/account/change-phone-number"
							className="w-full bg-white rounded-xl text-dark px-3"
						>
							<Box className="flex justify-start items-center gap-1 py-3 cursor-pointer">
								<PhoneIcon />
								<p className="text-sm font-medium flex flex-1">
									{t("changePhoneNumber")}
								</p>
								<ChevronRightIcon />
							</Box>
						</Link>
						<Link
							to="/dashboard/accounts/settings/account/change-password"
							className="w-full bg-white rounded-xl text-dark px-3"
						>
							<Box className="flex justify-start items-center gap-1 py-3 cursor-pointer">
								<LockIcon />
								<p className="text-sm font-medium flex flex-1">
									{t("changePassword")}
								</p>
								<ChevronRightIcon />
							</Box>
						</Link>
						{/* <Box className="w-full bg-white rounded-xl text-dark px-3">
							<Box className="flex justify-start items-center gap-1 py-3">
								<SecurityIcon />
								<p className="text-sm font-medium flex flex-1">Security</p>
							</Box>
							<Divider />
							<Box className="flex justify-start items-center gap-1 py-3">
								<p className="text-sm font-medium flex flex-1">
									Enable Biometric Sign In
								</p>
								<IOSSwitch />
							</Box>
						</Box> */}
					</Stack>
					<Link
						to="/dashboard/accounts/settings/account/delete-account"
						className="w-full"
					>
						<BasicButton
							component="span"
							variant="contained"
							color="error"
							className="submit w-full !h-14 !text-base !shadow-none !mt-10 !mb-2"
							startIcon={<PersonRemoveIcon />}
						>
							{t("deleteAccount")}
						</BasicButton>
					</Link>
				</Stack>
			</div>
		</div>
	);
}
